// Lightweight custom-select — replaces the native <select> on the quote form so
// the dropdown looks and behaves the same on every device (native selects render
// an OS picker on mobile that can't be styled). Progressive: the hidden input
// carries the value, so the form still submits if JS fails to load.
(function () {
  function initSelect(root) {
    if (root.dataset.qbSelectReady === 'true') return;
    root.dataset.qbSelectReady = 'true';

    const trigger = root.querySelector('[data-qb-select-trigger]');
    const panel = root.querySelector('[data-qb-select-panel]');
    const valueEl = root.querySelector('[data-qb-select-value]');
    const input = root.querySelector('[data-qb-select-input]');
    const options = Array.from(root.querySelectorAll('.qb-select__option'));
    if (!trigger || !panel) return;

    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick, true);
      document.addEventListener('keydown', onKey);
    }
    function close() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, true);
      document.removeEventListener('keydown', onKey);
    }
    function onDocClick(e) { if (!root.contains(e.target)) close(); }
    function onKey(e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    }
    function choose(opt) {
      options.forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-selected', 'false');
      });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-selected', 'true');
      const val = opt.getAttribute('data-value') || opt.textContent.trim();
      if (valueEl) valueEl.textContent = val;
      if (input) input.value = val;
      close();
      trigger.focus();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      panel.hidden ? open() : close();
    });
    options.forEach(function (opt) {
      opt.addEventListener('click', function () { choose(opt); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-qb-select]').forEach(initSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
